import { Coordinate } from '../navigation/coodinate';
import { LocationAccuracy } from '../navigation/locationAccuracy';
import { ParsedDate } from '../parsed/parsedDate';
import { z } from 'zod';

export const SessionLocation = Coordinate.extend({
    accuracy: LocationAccuracy.nullish(),
    cartId: z.string().nullish(),
    commodityGroup: z.string().nullish(),
    isHighPriorityLocation: z.boolean().nullish(),
    lat: z.number().nullish(),
    lon: z.number().nullish(),
    storeArea: z.string().nullish(),
    storeHasMultipleLevels: z.boolean().nullish(),
    systemId: z.number().nullish(),
    systemIdName: z.string().nullish(),
    ts: ParsedDate.nullish(),
});
export type SessionLocation = z.infer<typeof SessionLocation>;
